import { useAppReady } from "@/hooks/useAppReady";

export const GatedModals = ({ children }) => (useAppReady() ? children : null);
